import {axios} from '@/api/axios';
import {EventType} from '@/types/event-type';
import {formatString} from '@/utils';
import {Ticket} from '@/types/ticket';
import {TICKET_URLS} from '@/api/urls';
import {TicketCategory} from '@/types/ticket-category';
import {Statistic} from '@/types/statistic';

type ticketFilterType = { category: string, ticketMarkFilter: string, allCategory: TicketCategory[], onPage: number, offset: number };
const ticketFilter = (adress: string, filter: ticketFilterType) => {
  let link = adress + `?limit=${filter.onPage}&offset=${filter.offset}`;

  if (filter.ticketMarkFilter) {
    link = link + `&filter=mark||$cont||${filter.ticketMarkFilter}`;
  }
  if (filter.category) {
    link = link + `&filter=ticketCategory||$eq||${filter.category}`;
  }
  if (!filter.category) {
    link = link + `&filter=ticketCategory||$in||${filter.allCategory.map(c => c.id).toString()}`;
  }

  return link;
};

export interface FilterRes<T> {
  data: T[];
  count: number;
  total: number;
  page: number;
  pageCount?: number
}

export const TicketApi = {
  getList: () => axios.get<Ticket[]>(TICKET_URLS.GET_LIST),
  getListFilter: (filter: ticketFilterType) => axios.get<FilterRes<Ticket>>(ticketFilter(TICKET_URLS.GET_LIST, filter)),
  getOne: (categoryId: string) => axios.get<Ticket>(formatString(TICKET_URLS.GET_EVENT, categoryId)),
  getStatistic: (token: string) => axios.get<Statistic[]>(formatString(TICKET_URLS.GET_STATISTIC, token)),

  save: (data: Ticket) => axios.post<EventType>(TICKET_URLS.SAVE, data),
  saveBulk: (data: Ticket[]) => axios.post<EventType>(TICKET_URLS.SAVE_BULK, {bulk: data}),
  edit: (id: string, data: Ticket) => axios.put<Ticket>(formatString(TICKET_URLS.EDIT, id), data),
  editBulk: (data: Ticket[]) => axios.put<Ticket>(TICKET_URLS.SAVE_BULK, data),
  delete: (id: string) => axios.delete<Ticket>(formatString(TICKET_URLS.EDIT, id)),
  getCountByCategory: (data: { event: string, category: string[] }[]) => axios.post<{ event: string, count: number }[]>(TICKET_URLS.COUNT, {category: data})
};
